import {
    Button,
    CssBaseline,
    TextField,
    Link,
    Box,
    Typography,
    Container,
    IconButton,
    InputAdornment,
    createTheme,
    ThemeProvider,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SparklesBackground from './SparklesBackground';
import logo from './assets/logo.png';

function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://conscious-connections.com/en/">
                Conscious Connections
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const theme = createTheme({
    palette: {
        primary: { main: '#272B31' },
        secondary: { main: '#fffa00' },
        background: { default: '#f0f2f5' },
    },
    typography: {
        fontFamily: 'Inter, Roboto, Arial, sans-serif',
    },
});

export default function SignIn() {
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const user = JSON.parse(localStorage.getItem('concUser'));
    useEffect(() => {
        if (user?.token) navigate('/users');
    }, [navigate, user]);

    const loginUser = async (credentials) => {
        return fetch('/admin/api/v1/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(credentials),
        });
    };

    const validateCredentials = (userName) => {
        const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userName);
        if (!emailValid) {
            setError('Please enter a valid email address.');
            return false;
        }
        setError('');
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateCredentials(username)) return;

        const response = await loginUser({ email: username, password });

        if (response?.status === 200) {
            const res = await response.json();
            if (res?.payload) {
                localStorage.setItem(
                    'concUser',
                    JSON.stringify({
                        email: username,
                        token: res.payload.token,
                    })
                );
                navigate('/users');
            } else {
                setError('Unexpected error.');
            }
        } else {
            setError('Login failed.');
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    background: '#04070d',
                    overflow: 'hidden',
                }}
            >
              <SparklesBackground />

                <Container
                    maxWidth="xs"
                    sx={{
                        position: 'relative',
                        zIndex: 2,
                        background: 'rgba(255,255,255,0.9)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '24px',
                        boxShadow: '0 12px 42px rgba(0,0,0,0.82)',
                        py: 4,
                        textAlign: 'center',
                        padding: '50px'
                    }}
                >
                    <CssBaseline />

                    <Box sx={{ mb: 3 }}>
                        <img src={logo} alt="logo" style={{ width: 100 }} />
                    </Box>

                    <Typography variant="h5" sx={{ mb: 2 }}>
                        Login
                    </Typography>

                    <Box component="form" onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Email"
                            value={username}
                            onChange={(e) => setUserName(e.target.value)}
                        />

                        <TextField
                            fullWidth
                            margin="normal"
                            label="Password"
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() =>
                                                setShowPassword(!showPassword)
                                            }
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        {error && (
                            <Typography color="error">{error}</Typography>
                        )}

                        <Button fullWidth type="submit" sx={{ mt: 2 }}>
                            Login
                        </Button>
                    </Box>

                    <Copyright sx={{ mt: 4 }} />
                </Container>
            </Box>
        </ThemeProvider>
    );
}